import React from "react";
import { useTranslation } from "react-i18next";

import { legendItemStyle, legendStyle } from "./style";

const EarthquakeMagnitudeLegend = () => {
  const { t } = useTranslation();

  return (
    <div style={legendStyle}>
      <div>
        <b>{t("riskAssessment.earthquakeMagnitude")} (ITA)</b>
      </div>
      <div>
        <span style={legendItemStyle("#d7191c")}></span>
        {t("legend.epicenterLocation")}
      </div>

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          © CyStellar, {t("legend.dataFromINGV")}
        </span>
      </div>
    </div>
  );
};

export default EarthquakeMagnitudeLegend;
